module.exports = __webpack_public_path__ + "static/media/boy.72a31da0.png";